<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {

  },
  methods: {
    setBackground(){
      // document.body.style.background = "#666666"
    }
  },
  mounted(){
    this.setBackground()
  }
}
</script>

<style>
#app {
  width:100%;
  height:100%;
}
</style>
